import React from "react";

import AuthenticationCard from "../../../components/Authentication/AuthenticationCard";

import { CloudIcon, ServerStackIcon } from "@heroicons/react/24/outline";

const ServerConfigurationScreen = () => {
  const DEFAULT_ADDRESS = process.env.REACT_APP_BASE_URL;

  const serverConfiguration =
    DEFAULT_ADDRESS === "https://server.dermi.ai/dashboard-api/"
      ? "CLOUD"
      : "LOCAL";

  const ServerIcon =
    serverConfiguration === "CLOUD" ? CloudIcon : ServerStackIcon;

  return (
    <AuthenticationCard
      AuthenticationPromptTitle="Server Configuration"
      AuthenticationPromptText="Verify your Dermi.ai server configuration below."
    >
      <div className="flex flex-col items-center justify-center w-full sm:w-4/5 py-6 space-y-10">
        <div
          className={`flex items-center justify-center w-full py-4 space-x-3 select-none
                      rounded-md border border-neutral-300 bg-cyan-100`}
        >
          <ServerIcon className="h-10 w-10 text-neutral-700" />

          <p className="font-medium text-neutral-700 text-4xl">
            {serverConfiguration}
          </p>
        </div>

        <div
          className="flex flex-row items-center justify-center w-full select-none
        border border-1 border-neutral-300 rounded-md p-2
        "
        >
          <p className="font-normal text-neutral-600">{DEFAULT_ADDRESS}</p>
        </div>
      </div>
    </AuthenticationCard>
  );
};

export default ServerConfigurationScreen;
